import { LocationsActions } from "../../types";

export function create(data: Object): any {
  return {
    types: LocationsActions.RequirementFieldCreate,
    method: "post",
    url: `api/v1/requirement_fields`,
    data,
  };
}

export function update({ id, ...data }: any): any {
  return {
    types: LocationsActions.RequirementFieldUpdate,
    method: "put",
    url: `api/v1/requirement_fields/${id}`,
    data,
  };
}

export function destroy(id: number): any {
  return {
    types: LocationsActions.RequirementFieldDestroy,
    method: "delete",
    url: `api/v1/requirement_fields/${id}`,
  };
}
